import * as React from 'react';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { useGoogleMapsStaticMap, Loader, Alert } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useDispatch } from '@grandvisionhq/state';
import { rescheduleAppointment } from '../../../data-layer/appointments/actions.js';
import { useGetAppointmentById } from '../../hooks/useGetAppointmentById.js';
import AppointmentDetail from './AppointmentDetail.js';

const AppointmentDetailContainer = ({ appointmentId  })=>{
    const { dateTime , getFormattedLabel , getLabel  } = useIntl();
    const dispatch = useDispatch();
    const [storeDetailModalOpen, setStoreDetailModalOpen] = React.useState(false);
    const storeButtonRef = /*#__PURE__*/ React.createRef();
    const { data: appointment , loading , error  } = useGetAppointmentById(appointmentId);
    const returnLabel = encodeURIComponent(getLabel('appointments.rescheduling.returnLabel'));
    const { routes  } = useBloomreachPageRoutes();
    const rescheduleAppointmentRoute = routes['appointment-reschedule'];
    const cancelAppointmentRoute = routes['appointment-cancel'];
    const { href: appointmentsRoute  } = useLink({
        route: 'me.appointments'
    }) || {};
    const reschedulePath = rescheduleAppointmentRoute ? `${rescheduleAppointmentRoute}?id=${encodeURIComponent(appointmentId)}&returnPath=${appointmentsRoute}&returnLabel=${returnLabel}` : undefined;
    const cancelPath = cancelAppointmentRoute ? `${cancelAppointmentRoute}?id=${encodeURIComponent(appointmentId)}&returnPath=${appointmentsRoute}&returnLabel=${returnLabel}` : undefined;
    const dateAndTime = appointment ? `${dateTime.formatLongDate(appointment === null || appointment === void 0 ? void 0 : appointment.startTime)} - ${dateTime.formatTime(appointment === null || appointment === void 0 ? void 0 : appointment.startTime)}` : '';
    const store = appointment === null || appointment === void 0 ? void 0 : appointment.store;
    const mapImageUrl = useGoogleMapsStaticMap({
        lat: store === null || store === void 0 ? void 0 : store.lat,
        lon: store === null || store === void 0 ? void 0 : store.lon,
        params: '&style=feature:poi|visibility:off'
    });
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
        store === null || store === void 0 ? void 0 : store.streetName.split(' '),
        store === null || store === void 0 ? void 0 : store.streetNumber,
        store === null || store === void 0 ? void 0 : store.town
    ].join(' ').trim())}`;
    const labels = {
        additionalInfo: getLabel('appointments.page.reschedule.confirm.additionalInformation'),
        addToCalendar: getLabel('appointments.confirmation.addToCalendar'),
        appointments: getLabel('account.menu.appointments'),
        breadcrumb: getLabel('account.appointment.detail.breadcrumb'),
        cancel: getLabel('account.appointment.cancel.title'),
        detailError: getLabel('account.appointment.detail.error'),
        getDirections: getLabel('appointments.confirmation.getDirections'),
        reschedule: getLabel('account.appointment.action.reschedule'),
        reservationInfo: getFormattedLabel('appointments.reservation.infoAlert.message', {
            parseHTML: true
        }),
        reservationTitle: getFormattedLabel('appointments.reservation.infoAlert.title', {
            parseHTML: true
        }),
        viewStoreDetails: getLabel('appointments.component.storeOverview.storeDetailLink'),
        when: getLabel('appointments.component.navigationContainer.step.when'),
        where: getLabel('appointments.component.navigationContainer.step.where'),
        who: getLabel('appointments.component.navigationContainer.step.who')
    };
    const handleOnReschedule = ()=>{
        appointment && dispatch(rescheduleAppointment(appointment));
    };
    const handleOpenStoreDetailModal = React.useCallback(()=>setStoreDetailModalOpen(true)
    , []);
    const handleCloseStoreDetailModal = React.useCallback(()=>{
        var ref;
        (ref = storeButtonRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        setStoreDetailModalOpen(false);
    }, [
        storeButtonRef
    ]);
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (error || !appointment) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            icon: "info"
        }, labels.detailError);
    }
    return /*#__PURE__*/ React.createElement(AppointmentDetail, {
        appointmentType: appointment.appointmentType,
        cancelLink: cancelPath,
        customerComment: appointment.customerComment,
        dateAndTime: dateAndTime,
        directionsUrl: directionsUrl,
        endTime: appointment.endTime,
        invitee: appointment.invitee,
        isCancellable: appointment.isCancellable,
        isReschedulable: appointment.isReschedulable,
        isReservation: appointment.isReservation,
        labels: labels,
        mapImageUrl: mapImageUrl,
        onReschedule: handleOnReschedule,
        onStoreDetailModalClose: handleCloseStoreDetailModal,
        onStoreDetailModalOpen: handleOpenStoreDetailModal,
        rescheduleLink: reschedulePath,
        startTime: appointment.startTime,
        storeDetailModalOpen: storeDetailModalOpen,
        store: store
    });
};
var AppointmentDetailContainer$1 = AppointmentDetailContainer;

export { AppointmentDetailContainer$1 as default };
//# sourceMappingURL=AppointmentDetailContainer.js.map
